import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import "../../assets/css/Home.css";
import {
  arrow2,
  arrow3,
  pro1,
  pro2,
  pro3,
  videoImage,
  videoImage1,
  videoImage2,
} from "../../constant";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer/Footer";
import HomeContactForm from "../../Components/Forms/HomeContactForm";
import Slider from "react-slick";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ActionButton from "../../Components/ActionBtn/ActionButton";
import {
  GetAboutUs,
  GetGalleryImage,
  GetNewsList,
  GetPlantsApi,
  PostNewsLetter,
} from "../../network/Network";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";

function Home() {
  const [plantsData, setPlantsData] = useState(null);
  const ImageUrlRedux = useSelector((state) => state?.AuthReducer?.urlData);
  const siteSetting = useSelector((state) => state?.AuthReducer?.siteSettings);
  const [aboutUs, setAboutUs] = useState(null);
  const [newsEmail, setNewsEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [spinLoad, setSpinLoad] = useState(false);
  const [galleryData, setGalleryData] = useState(null);
  const [newsList, setNewsList] = useState(null);
  const navigate = useNavigate();
  const social = useSelector((state) => state?.AuthReducer?.socialData);
  const getAllPlantsApiCall = () => {
    setLoading(true);
    let data = {
      name: "/all-plants",
      color: "",
      species: "",
      leaf_type: "",
      growth_rate: "",
      hardiness_zone: "",
      start_price: "",
      end_price: "",
      search: "",
    };
    GetPlantsApi(1, data)
      .then((res) => {
        setLoading(false);
        setPlantsData(res?.data?.data);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    GetGalleryImage()
      .then((res) => {
        setGalleryData(res?.data?.response.data);
        setSpinLoad(false);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setSpinLoad(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    GetAboutUs()
      .then((res) => {
        setLoading(false);
        setAboutUs(res.data);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    GetNewsList()
      .then((res) => {
        setLoading(false);
        setNewsList(res.data);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  var settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 786,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllPlantsApiCall();
  }, []);

  const SubmitNewsLetter = (e) => {
    setLoading(true);
    e.preventDefault();
    if (!newsEmail) {
      toast.error("Please Enter Email Address");
      setLoading(false);
      return;
    }
    if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        newsEmail
      )
    ) {
      toast.error("Invalid Email");
      setLoading(false);
      return;
    }
    let data = {
      email: newsEmail,
    };
    PostNewsLetter(data)
      .then((res) => {
        toast.success(res?.data?.message);
        setLoading(false);
        setNewsEmail("");
      })
      .catch((err) => {
        if (err?.response?.data?.errors[0]?.code == "email") {
          toast.error(err?.response?.data?.errors[0]?.message);
          setLoading(false);
          return;
        }
        if (err?.response?.data?.errors?.email) {
          toast.error(err?.response?.data?.errors?.email[0]);
          setLoading(false);
          return;
        }
        setLoading(false);
      });
  };

  return (
    <>
      <Header />
      <section
        style={{
          backgroundImage: `url("${ImageUrlRedux?.hoho_shop_image_url}/${siteSetting?.hoho_shop_banner}")`,
        }}
        className="home-banner"
      >
        <div className="container">
          <div className="banner-cont">
            <h2 className="main-point animate__animated animate__backInDown">
              {siteSetting?.hoho_company_banner_title}{" "}
            </h2>
            <h3 className="main-title animate__animated animate__backInLeft">
              {siteSetting?.hoho_company_banner_sub_title}
            </h3>
            <p className="para animate__animated animate__backInLeft">
              {siteSetting?.hoho_company_banner_content}
            </p>
          </div>
        </div>

        <div className="btn-gr">
          <button
            onClick={() => {
              navigate("/booking-membership");
            }}
            className="btn book-btn btn_absolute "
          >
            BOOK NOW &nbsp;
            <img
              src={arrow2}
              className="image-fluid arrow-img-home-new"
              alt=""
            />{" "}
          </button>
        </div>
      </section>
      <section className="home-about">
        <div className="container">
          <div>
            <h2 className="shadow-title">About</h2>
          </div>
          {loading ? (
            <Skeleton count={10} />
          ) : (
            <div className="row">
              <div className="col-lg-3">
                <div className="img-cont">
                  <img
                    src={`${ImageUrlRedux?.hoho_about_url}/${aboutUs?.image?.[0]}`}
                    alt=""
                    className="image-fluid home-about-image arrow-img-home-new img_one_home_about_sec"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="home-about-section">
                  <h3 className="about-title">{aboutUs?.title}</h3>
                  <p className="para">{aboutUs?.description}</p>
                </div>
                <div className="btn-container margin_sett">
                  <button
                    onClick={() => {
                      navigate("/booking-membership");
                    }}
                    className="btn BOOKNOW"
                  >
                    Book Now
                    <img
                      src={arrow3}
                      className="image-fluid ml-2 arrow-img-home-new"
                    />
                  </button>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="img-cont margin_set margin_btm">
                  <img
                    src={`${ImageUrlRedux?.hoho_about_url}/${aboutUs?.image?.[1]}`}
                    alt=""
                    className="image-fluid home-about-image2 arrow-img-home-new img_one_home_about_sec"
                  />
                </div>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-lg-4  margin_set2">
              <div className="img-cont img-data">
                <img
                  src={`${ImageUrlRedux?.hoho_about_url}/${aboutUs?.image?.[2]}`}
                  // src={ab2}
                  alt=""
                  className="image-fluid home-about-image3 arrow-img-home-new img_three_home_about_sec"
                />
              </div>
            </div>
            <div className="col-lg-4 margin_set2">
              <div className="img-cont img-data">
                <img
                  // src={ab1}
                  src={`${ImageUrlRedux?.hoho_about_url}/${aboutUs?.image?.[3]}`}
                  alt=""
                  className="image-fluid home-about-image4 arrow-img-home-new img_six_home_about_sec"
                />
              </div>
            </div>
            <div className="col-lg-4 margin_set2">
              <div className="img-cont img-data">
                <img
                  // src={ab3}
                  src={`${ImageUrlRedux?.hoho_about_url}/${aboutUs?.image?.[4]}`}
                  alt=""
                  className="image-fluid home-about-image5 arrow-img-home-new img_five_home_about_sec"
                />
              </div>
            </div>
          </div>
        </div>

        <section className="home-product">
          <div className="container">
            <div>
              <h2 className="shadow-title">Products</h2>
            </div>
            <div className="row justify_center">
              <div className="col-lg-12">
                <h3 className="about-title">Browse Our Products</h3>
              </div>
              {loading ? (
                <Skeleton count={10} />
              ) : (
                <>
                  {plantsData?.slice(0, 3)?.map((item, index) => {
                    return (
                      <div
                        onClick={() => {
                          navigate(`/product-detail/${item.id}`);
                        }}
                        className="col-lg-4 product-card cursor_pointer"
                        key={index}
                      >
                        <div className="px-2 pt-4">
                          <img
                            src={`${ImageUrlRedux?.product_thumbnail_url}/${item?.thumbnail}`}
                            alt=""
                            className="image-fluid arrow-img-home-new"
                          />
                        </div>
                        <div className="content">
                          <p className="title">{item?.name}</p>
                          <p className="price">${item?.unit_price} </p>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </section>

        <section className="home-social">
          <div className="container">
            <div>
              <h2 className="shadow-title">Social Media</h2>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <h3 className="about-title mb-3">Follow Us on Social Media</h3>
              </div>
              <div className="col-lg-12 ">
                <div className="all-icon">
                  <div className="row justify-center">
                    {social?.[6]?.active_status == 1 ? (
                      <div className="col-lg-4">
                        <div>
                          <a href={`${social?.[6]?.link}`} target="_blank">
                            <div className="icon-bg">
                              <i
                                className={social?.[6]?.icon}
                                aria-hidden="true"
                              ></i>
                              {/* <img src={icon1} alt="" className="image-fluid" /> */}
                            </div>
                            <p className="icon-name">{social?.[6]?.name}</p>
                          </a>
                        </div>
                      </div>
                    ) : null}
                    {social?.[0]?.active_status == 1 ? (
                      <div className="col-lg-4">
                        <div>
                          <a href={`${social?.[0]?.link}`} target="_blank">
                            <div className="icon-bg">
                              <i
                                className={social?.[0]?.icon}
                                aria-hidden="true"
                              ></i>
                              {/* <img src={icon2} alt="" className="image-fluid" /> */}
                            </div>
                            <p className="icon-name">{social?.[0]?.name}</p>
                          </a>
                        </div>
                      </div>
                    ) : null}
                    {social?.[3]?.active_status == 1 ? (
                      <div className="col-lg-4">
                        <div>
                          <a href={`${social?.[3]?.link}`} target="_blank">
                            <div className="icon-bg">
                              <i
                                className={social?.[3]?.icon}
                                aria-hidden="true"
                              ></i>
                              {/* <img src={icon3} alt="" className="image-fluid" /> */}
                            </div>
                            <p className="icon-name">{social?.[3]?.name}</p>
                          </a>
                        </div>
                      </div>
                    ) : null}
                    {social?.[4]?.active_status == 1 ? (
                      <div className="col-lg-4">
                        <div>
                          <a href={`${social?.[4]?.link}`} target="_blank">
                            <div>
                              <div className="icon-bg">
                                <i
                                  className={social?.[4]?.icon}
                                  aria-hidden="true"
                                ></i>
                                {/* <img src={icon4} alt="" className="image-fluid" /> */}
                              </div>
                              <p className="icon-name">{social?.[4]?.name}</p>
                            </div>
                          </a>
                        </div>
                      </div>
                    ) : null}
                    {social?.[5]?.active_status == 1 ? (
                      <div className="col-lg-4">
                        <div>
                          <a href={`${social?.[5]?.link}`} target="_blank">
                            <div className="icon-bg">
                              <i
                                className={social?.[5]?.icon}
                                aria-hidden="true"
                              ></i>
                              {/* <img src={icon5} alt="" className="image-fluid" /> */}
                            </div>
                            <p className="icon-name"> {social?.[5]?.name}</p>
                          </a>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="home-post">
          <div className="container">
            {loading ? (
              <Skeleton count={10} />
            ) : (
              <>
                {newsList?.map((item, index) => {
                  if (index % 2 === 0) {
                    return (
                      <div className="row">
                        <div className="col-lg-5 ">
                          <div className="img-cont lecture_Img">
                            <img
                              src={`${ImageUrlRedux?.hoho_newslist_url}/${item?.image}`}
                              alt=""
                              className="image-fluid home-post-image1 arrow-img-home-new img_home_green_layout  "
                            />
                          </div>
                        </div>
                        <div className="col-lg-7">
                          <div className="set_para_home">
                            <h2 className="shadow-title mb-3">
                              {item?.sub_title}
                            </h2>
                            <h3 className="main-title">{item?.title} </h3>
                            <p className="para txt_elipses_six_lines mt-3">
                              {item?.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div className="row">
                        <div className="col-lg-7">
                          <div className="set_para_home">
                            <h2 className="shadow-title mb-3">
                              {item?.sub_title}
                            </h2>
                            <h3 className="main-title">{item?.title} </h3>
                            <p className="para txt_elipses_six_lines mt-3">
                              {item?.description}
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-5 ">
                          <div className="img-cont lecture_Img">
                            <img
                              src={`${ImageUrlRedux?.hoho_newslist_url}/${item?.image}`}
                              alt=""
                              className="image-fluid home-post-image1 arrow-img-home-new img_home_green_layout"
                            />
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
              </>
            )}
          </div>
        </section>

        <section
          className="home-video"
          style={{ zIndex: "9", position: "relative" }}
        >
          <div className="container">
            <div>
              <h2 className="shadow-title">Our Farm</h2>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <h3 className="about-title">Have a look At our Farm</h3>
              </div>
            </div>
            {loading ? (
              <Skeleton count={10} />
            ) : (
              <div className="row">
                <div className="col-md-12">
                  <div className="ourfarm_carousel">
                    <Slider {...settings}>
                      {galleryData?.map((item, index) => {
                        return (
                          <img
                            key={index + 658432}
                            src={`${item?.full_media_url}`}
                            alt="allImages"
                            className="image-fuild arrow-img-home-new home_"
                          />
                        );
                      })}
                    </Slider>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <section
          className="home-newsLetter"
          style={{ zIndex: "9", position: "relative" }}
        >
          <div className="container newsLetter-align">
            <div className="row">
              <div className="col-lg-6">
                <p className="main-title">Subscribe to Our Newsletter</p>
              </div>
              <div className="col-lg-4">
                <input
                  className="newletter-input"
                  type="text"
                  placeholder="Write your Email"
                  value={newsEmail}
                  onChange={(e) => setNewsEmail(e.target.value)}
                />
              </div>
              <div className="col-lg-2">
                <button
                  className="btn book-btn"
                  onClick={(e) => SubmitNewsLetter(e)}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Submit"}
                  <img
                    src={arrow2}
                    className="image-fluid arrow-img-home-new"
                    alt=""
                  />{" "}
                </button>
              </div>
            </div>
          </div>
        </section>

        <HomeContactForm />
      </section>
      <ActionButton />

      <Footer />
    </>
  );
}

export default Home;
